import React from 'react';
import { Button } from '@mui/material';
import styles from './styles.module.scss';

const StandardNavigationButton = ({
  id,
  label,
  link,
  action,
  color = 'inherit',
  className = styles.navButton,
  anchorClassName = styles.anchor,
  startIcon = null,
  endIcon = null,
}) => {
  const normalizedLabel = typeof label === 'string' ? label : String(label);
  const idf = normalizedLabel.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

  const handleAnchorClick = (event) => {
    event.preventDefault();
  };

  return (
    <Button
      id={id}
      color={color}
      onClick={action}
      className={className}
      data-testid={`navigation-button-main-header-${idf}`}
      startIcon={startIcon}
      endIcon={endIcon}
    >
      {!!link ? (
        <a
          href={link}
          onClick={handleAnchorClick}
          className={anchorClassName}
          data-testid={`navigation-link-main-header-${idf}`}
        >
          {normalizedLabel}
        </a>
      ) : normalizedLabel}
    </Button>
  );
};

export default StandardNavigationButton;
